import { Pressable } from 'react-native';
import { Icon } from '@/common/components/Icons/Icon';
import { IconSemiCircle } from '@/common/components/Icons/custom/IconSemiCircle';
import { Stack } from '@/common/components/Stack/Stack';
import { styles } from './TopBar.styles';

export type TopBarProps = {
  onBack?: () => void;
  onClose?: () => void;
};

export function TopBar({ onBack, onClose }: TopBarProps) {
  return (
    <Stack horizontal align="center" shrink={false} className={styles.root}>
      <Pressable onPress={onBack} className={styles.button}>
        {onBack && <Icon icon="arrow-left-long" color="neutral30" />}
      </Pressable>
      <Stack grow align="center">
        <IconSemiCircle />
      </Stack>
      <Pressable onPress={onClose} className={styles.button}>
        {onClose && <Icon icon="close" color="neutral30" />}
      </Pressable>
    </Stack>
  );
}
